import { Components, alertClasses } from '@mui/material';
import { Theme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    iconMapping: {
      success: <CheckCircleIcon />,
      error: <ErrorIcon />,
      info: <InfoIcon />,
      warning: <WarningIcon />,
    },
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      ...theme.typography.label1,
      ...(ownerState.severity === 'success' &&
        ownerState.variant === 'standard' && {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.text.primary,
          [`& .${alertClasses.icon}`]: {
            color: theme.palette.success.main,
          },
        }),
      ...(ownerState.severity === 'error' &&
        ownerState.variant === 'standard' && {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.text.primary,
          [`& .${alertClasses.icon}`]: {
            color: theme.palette.error.main,
          },
        }),
    }),
  },
};
